/* eslint-disable @typescript-eslint/no-unused-vars */
import { FooterLinkType } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

export const footerLinks: (t: ContextApi['t']) => FooterLinkType[] = (t) => [
  // {
  //   label: t('About'),
  //   items: [
  //     {
  //       label: t('Contact'),
  //       href: 'https://docs.punkswap.exchange/contact-us',
  //       isHighlighted: true,
  //     },
  //     {
  //       label: t('Blog'),
  //       href: 'https://docs.punkswap.exchange/contact-us',
  //     },
  //     {
  //       label: t('Community'),
  //       href: 'https://docs.punkswap.exchange/contact-us/telegram',
  //     },
  //     {
  //       label: t('Litepaper'),
  //       href: 'https://docs.punkswap.exchange/brand',
  //     },
  //     {
  //       label: t('SWAP Emission Projection'),
  //       href: 'https://docs.punkswap.exchange/brand',
  //     },
  //     // {
  //     //   label: '—',
  //     // },
  //   ],
  // },
  // {
  //   label: t('Help'),
  //   items: [
  //     {
  //       label: t('Customer Support'),
  //       href: 'https://docs.punkswap.exchange/contact-us/customer-support',
  //     },
  //     {
  //       label: t('Troubleshooting'),
  //       href: 'https://docs.punkswap.exchange/get-started',
  //     },
  //     {
  //       label: t('Guides'),
  //       href: 'https://docs.punkswap.exchange/get-started',
  //     },
  //   ],
  // },
  // {
  //   label: t('Developers'),
  //   items: [
  //     {
  //       label: 'Github',
  //       href: '',
  //     },
  //     {
  //       label: t('Documentation'),
  //       href: 'https://docs.punkswap.exchange/',
  //     },
  //     // {
  //     //   label: t('Audits'),
  //     //   href: 'https://www.rdauditors.com/audits/',
  //     // },
  //   ],
  // },
]
